module.exports = __webpack_public_path__ + "static/media/person.83c6807e.svg";